<template>
  <div class="project-materials" v-if="project">
    <div class="accordion" role="tablist">
      <!-- New Orders Section -->
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.materials-new-orders
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-shopping-cart mr-2"></i>Bestellungen (neu)
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse
          id="materials-new-orders"
          accordion="materials-accordion"
          role="tabpanel"
          visible
        >
          <div class="accordion-content p-3 border border-top-0">
            <ProjectOrders :project="project" />
          </div>
        </b-collapse>
      </div>

      <!-- Orders Section -->
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.materials-orders
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-list mr-2"></i>{{ $t('orders') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse id="materials-orders" accordion="materials-accordion" role="tabpanel" visible>
          <div class="accordion-content p-3 border border-top-0">
            <!-- Order Status Fields -->
            <ProjectOrderSettings :project="project" />

            <!-- Item Selection and Project Items -->
            <b-row>
              <b-col lg="6" md="6" sm="12" v-if="project.items">
                <ItemSelect
                  v-on:item-select:add-item="onAddItemToProject"
                  v-on:item-select:remove-item="onRemoveItemFromProject"
                />
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <ProjectItems
                  :items="items"
                  v-on:item-select:remove-all-items="onRemoveAllItemsFromProject"
                  :project="project"
                />
              </b-col>
            </b-row>
          </div>
        </b-collapse>
      </div>

      <!-- Inventory Section -->
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.materials-inventory
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-cubes mr-2"></i>{{ $t('inventory') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse id="materials-inventory" accordion="materials-accordion" role="tabpanel">
          <div class="accordion-content p-3 border border-top-0">
            <ProjectItemInventory :project="project" />
          </div>
        </b-collapse>
      </div>

      <!-- Consumed Items Section -->
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.materials-consumed
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-rocket mr-2"></i>{{ $t('consumed_items') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse id="materials-consumed" accordion="materials-accordion" role="tabpanel">
          <div class="accordion-content p-3 border border-top-0">
            <ProjectItemsConsumed :project="project" />
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectItems from './ProjectItems';
import ItemSelect from './ItemSelect';
import ProjectOrderSettings from './ProjectOrderSettings';
import ProjectItemInventory from './ProjectItemInventory';
import ProjectItemsConsumed from './ProjectItemsConsumed';
import ProjectOrders from './ProjectOrders';

export default {
  name: 'ProjectMaterials',
  components: {
    ProjectItems,
    ItemSelect,
    ProjectOrderSettings,
    ProjectItemInventory,
    ProjectItemsConsumed,
    ProjectOrders,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    items() {
      return this.project.items;
      //   const itemTypes = ['STANDARD', 'AC', 'DC'];
      // return this.project.items
      //   ? this.project.items.filter((item) => itemTypes.includes(item.item.type))
      //   : [];
    },
  },
  methods: {
    /** */
    onAddItemToProject(itemData) {
      console.log('onAddItemToProject()', parseInt(itemData.addRemoveCount), itemData);
      const addRemoveCount = parseInt(itemData.addRemoveCount);
      const item = this.project.items.find((item) => item.item._id == itemData._id);
      if (item) {
        item.count += addRemoveCount;
      } else {
        const newItem = {
          count: addRemoveCount,
          item: itemData,
        };
        this.project.items.push(newItem);
      }
    },

    /** */
    onRemoveItemFromProject(itemData) {
      const addRemoveCount = parseInt(itemData.addRemoveCount);
      const item = this.project.items.find((item) => item.item._id == itemData._id);
      if (item) {
        item.count -= addRemoveCount;
        if (item.count <= 0) {
          const index = this.project.items.findIndex((item) => item.item._id == itemData._id);
          // console.log(index);
          this.project.items.splice(index, 1);
        }
      }
    },

    async onRemoveAllItemsFromProject() {
      this.project.items = [];
    },
  },
};
</script>

<style scoped lang="scss">
.accordion {
  .accordion-header {
    font-weight: 600;
    color: #495057;
    border: 1px solid #dee2e6;
    background-color: #f8f9fa;

    &:hover {
      background-color: #e9ecef;
      border-color: #adb5bd;
    }

    &:focus {
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }

    &[aria-expanded='true'] {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;

      .fa-chevron-down {
        transform: rotate(180deg);
      }
    }

    .fa-chevron-down {
      transition: transform 0.2s ease;
    }
  }

  .accordion-content {
    background-color: #fff;
    border-color: #dee2e6;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
}

// Legacy legend styles (kept for reference)
legend {
  font-size: 1.1rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 1rem;

  i {
    color: #6c757d;
  }
}
</style>
